<template>
  <div class="financials">
    <div>
      <title-temp title="Total"></title-temp>
      <line-chart :xData="xData" :serData="serData"></line-chart>
    </div>

    <div class="financials_container clearfix">
      <slot name="info"></slot>
    </div>

    <!-- Key financials & employees -->
    <div class="employees table-header downContainer" v-if="currentDataSource=='bvd'">
      <!-- <el-button
        type="text"
        v-if="allKey.COMPANY_DOWNLOAD"
        class="downLoadBtn paddingBtn"
        @click="downLoadFn(employeesData, Config.employeesColumn,`Key financials & employees`,KeyFinancialEmployeesUnit)"
      >
        <i class="el-icon-download"></i>
        download
      </el-button> -->
      <title-temp title="Key financials & employees"></title-temp>
      <p class="unit">Exchange rate: {{KeyFinancialEmployeesUnit}}</p>
      <table-form
        :columnData="Config.employeesColumn"
        :tableData="employeesData"
        largeLabelCls="largeLabel"
      ></table-form>
    </div>

    <!-- Key financials -->
    <div class="key_financials table-header downContainer" v-if="currentDataSource!='bvd'">
      <!-- <el-button
        type="text"
        class="downLoadBtn paddingBtn"
        v-if="allKey.COMPANY_DOWNLOAD"
        @click="downLoadFn(keyFinancialsData, Config.keyFinancialsColumn,`Key financials`,KeyFinancialUnit)"
      >
        <i class="el-icon-download"></i>
        download
      </el-button> -->
      <title-temp title="Key financials"></title-temp>
      <el-select
        v-model="keyFinancialsQuarter"
        placeholder="select the querater"
        class="qurarter_cls"
        @change="keyFinancialsChange"
      >
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <p class="unit">Exchange rate: {{KeyFinancialUnit}}</p>
      <table-form :columnData="Config.keyFinancialsColumn" :tableData="keyFinancialsData"></table-form>
    </div>

    <!-- Global standard format-->
    <div class="global_standard_format table-header" v-if="currentDataSource=='bvd'">
      <title-temp title="Global standard format"></title-temp>
      <!-- <el-select v-model="globalQuarter" placeholder="select the querater" class="qurarter_cls">
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>-->
      <!-- <p class="unit">Exchange rate: CNY/USD</p> -->
      <div class="third_module">
        <p class="module_title downContainer">
          Assets
          <span class="unit">(Exchange rate: {{assetsUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(globalAssetsData, globalAssetsColumnData,`Global standard format-Assets`,assetsUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="globalAssetsColumnData" :tableData="globalAssetsData"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          Liabilities & equity
          <span class="unit">(Exchange rate: {{LiabilitiesUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(equityData, equityColumnData,`Global standard format-Liabilities & equity`,LiabilitiesUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="equityColumnData" :tableData="equityData"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          Profit & loss account
          <span class="unit">(Exchange rate: {{ProfitUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(profitData, profitColumnData,`Global standard format-Profit & loss account`,ProfitUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="profitColumnData" :tableData="profitData"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          Memo lines
          <span class="unit">(Exchange rate: {{MemoUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(memoData, memoColumnData,`Global standard format-Memo lines`,MemoUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="memoColumnData" :tableData="memoData"></table-form>
      </div>
    </div>

    <!-- Financial Statements -->
    <div class="financial_statements table-header" v-if="currentDataSource!='bvd'">
      <title-temp title="Financial Statements"></title-temp>
      <el-select
        v-model="fstatementQuarter"
        placeholder="select the querater"
        class="qurarter_cls"
        @change="financialStateChange"
      >
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <!-- <p class="unit">Exchange rate: CNY/USD</p> -->
      <div class="third_module">
        <p class="module_title downContainer">
          Income Statement
          <span class="unit">(Exchange rate: {{IncomeUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(incomeData, Config.incomeColumn,`Financial Statements-Income Statement`,IncomeUnit)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button> -->
        </p>
        <table-form :columnData="Config.incomeColumn" :tableData="incomeData"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          Balance Sheet
          <span class="unit">(Exchange rate: {{balanceUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(balanceData, Config.balanceColumn,`Financial Statements-Balance Sheet`,balanceUnit)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button> -->
        </p>
        <table-form :columnData="Config.balanceColumn" :tableData="balanceData"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          Cash Flow Statement
          <span class="unit">(Exchange rate: {{cashFlowUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(cashFlowData, Config.cashFlowColumn,`Financial Statements-Cash Flow Statement`,cashFlowUnit)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button> -->
        </p>
        <table-form :columnData="Config.cashFlowColumn" :tableData="cashFlowData"></table-form>
      </div>
    </div>

    <!-- Global ratios -->
    <div class="global_ratios" v-if="currentDataSource=='bvd'">
      <title-temp title="Global ratios"></title-temp>
      <!-- <p class="unit">Exchange rate: CNY/USD</p> -->
      <div class="third_module">
        <p class="module_title downContainer">
          {{ratios1Title}}
          <span class="unit">(Exchange rate: {{ratios1Unit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(ratios1Data, ratios1ColumnData,`Global ratios-${ratios1Title}`,ratios1Unit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="ratios1ColumnData" :tableData="ratios1Data"></table-form>
      </div>
      <div class="third_module">
        <p class="module_title downContainer">
          {{ratios2Title}}
          <span class="unit">(Exchange rate: {{ratios2Unit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(ratios2Data, ratios2ColumnData,`Global ratios-${ratios2Title}`,ratios2Unit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="ratios2ColumnData" :tableData="ratios2Data"></table-form>
      </div>
      <div class="third_module" v-if="this.currentType!='insurance'">
        <p class="module_title downContainer">
          {{ratios3Title}}
          <span class="unit">(Exchange rate: {{ratios3Unit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(ratios3Data, ratios3ColumnData,`Global ratios-${ratios3Title}`,ratios3Unit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="ratios3ColumnData" :tableData="ratios3Data"></table-form>
      </div>
      <div class="third_module" v-if="this.currentType!='insurance'">
        <p class="module_title downContainer">
          {{ratios4Title}}
          <span class="unit">(Exchange rate: {{ratios4Unit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(ratios4Data, ratios4ColumnData,`Global ratios-${ratios4Title}`,ratios4Unit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form :columnData="ratios4ColumnData" :tableData="ratios4Data"></table-form>
      </div>
    </div>

    <div class="cash_flow">
      <title-temp title="Cash flow statement"></title-temp>
      <!-- <el-select v-model="cashFlowQuarter" placeholder="请选择季度" class="qurarter_cls">
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>-->
      <div class="third_module">
        <p class="module_title downContainer">
          Operating cash flows
          <span class="unit">(Exchange rate: {{OperatingUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(operatingCashFlowData, Config1.operatingCashFlow,`Operating cash flows`,OperatingUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form
          :columnData="Config1.operatingCashFlow"
          :tableData="operatingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title downContainer">
          Investing cash flows
          <span class="unit">(Exchange rate: {{InvestingUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(investingCashFlowData, Config1.investingCashFlow,`Investing cash flows`,InvestingUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form
          :columnData="Config1.investingCashFlow"
          :tableData="investingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title downContainer">
          Financing cash flows
          <span class="unit">(Exchange rate: {{financingCFUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(financingCashFlowData, Config1.financingCashFlow,`Financing cash flows`,financingCFUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form
          :columnData="Config1.financingCashFlow"
          :tableData="financingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Balance
          <span class="unit">(Exchange rate: {{cfBalanceUnit}}):</span>
          <!-- <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.COMPANY_DOWNLOAD"
            @click="downLoadFn(balanceCashFlowData, Config1.balance,`Balance cash flows`,cfBalanceUnit)"
          >
            <i class="el-icon-download"></i>download
          </el-button> -->
        </p>
        <table-form
          :columnData="Config1.balance"
          :tableData="balanceCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>
    </div>
  </div>
</template>


<script>
import TitleTemp from "common/components/Title";
import TableList from "common/components/table";
import TableForm from "common/components/tableForm";
/**
 * f10只显示 Key financials  Financial Statements  需要季度筛选
 *
 * BVD 显示 Key financials & employees   Global standard format（普通公司）  Global ratios（普通公司）
 * 其中(Global standard format / Global ratios)分为 银行保险 普通公司
 * 不需要季度筛选
 */

import Config from "conf/Financials";
import Config1 from "conf/FinCompanies";

import Quarter from "conf/Quarter";
import { getBasic, getCompanyFinancial } from "common/js/http/v2Api";
import LineChart from "../../BarLine";
import { mapState, mapMutations } from "vuex";

const color = [
  "#836FFF",
  "#71C671",
  "#BCD2EE",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#A2B5CD",
  "#FFC125",
  "#757575",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC125",
  "#757575"
];

export default {
  props: ["conditions"],

  components: {
    TableList,
    TitleTemp,
    TableForm,
    LineChart
  },

  data() {
    return {
      Config,
      Config1,
      id: this.conditions.id,
      code: this.conditions.code,
      quarterOptions: Quarter,
      currentType: "bx",
      currentDataSource: "",
      exchangeInfo: "",
      allData: {},

      employeesData: {},

      keyFinancialsQuarter: 4,

      keyFinancialsData: {},

      //

      globalAssetsColumnData: [],
      globalAssetsData: {},

      equityColumnData: [],
      equityData: {},

      profitColumnData: [],
      profitData: {},

      memoColumnData: [],
      memoData: {},

      //
      fstatementQuarter: 4,
      // incomeColumn,
      incomeData: {},

      // balanceColumn,
      balanceData: {},

      // cashFlowColumn,
      cashFlowData: {},

      //
      // globalRatiosQuarter: 1,
      ratios1Title: "",
      ratios2Title: "",
      ratios3Title: "",
      ratios4Title: "",

      ratios1ColumnData: [],
      ratios2ColumnData: [],
      ratios3ColumnData: [],
      ratios4ColumnData: [],

      ratios1Data: {},
      ratios2Data: {},
      ratios3Data: {},
      ratios4Data: {},

      // cash flow
      operatingCashFlowData: {},
      investingCashFlowData: {},
      financingCashFlowData: {},
      balanceCashFlowData: {},

      // unit
      KeyFinancialUnit: "",
      IncomeUnit: "",
      balanceUnit: "",
      cashFlowUnit: "",
      OperatingUnit: "",
      InvestingUnit: "",
      financingCFUnit: "",
      cfBalanceUnit: "",
      KeyFinancialEmployeesUnit: "",
      assetsUnit: "",
      LiabilitiesUnit: "",
      ProfitUnit: "",
      MemoUnit: "",
      ratios1Unit: "",
      ratios2Unit: "",
      ratios3Unit: "",
      ratios4Unit: "",

      xData: [],
      serData: []
    };
  },

  created() {
    this.setDataSource();
    // this.setColumn();
  },

  methods: {
    async setDataSource() {
      const { result } = await getBasic(this.id, this.code);
      // const { result } = await getBasic("CN30262PC", "000063");

      this.currentDataSource = result.dataSource;
      this.exchangeInfo = result["Key information"].stock_exchange_listed;
      this.getData();
    },

    async getData() {
      const params = {
        bvdId: this.id,
        exchangeCode: this.exchangeInfo,
        stockCode: this.code
      };

      if (this.currentDataSource == "f10") {
        params.quarter = 4;
      }
      const { result } = await getCompanyFinancial(params);
      this.allData = result;
      if (this.currentDataSource == "bvd") {
        this.currentType = result.financialStatement.companyType;
        this.setColumn();
      }
      this.setTableData(result);
      this.getChartData(result);
    },

    setColumn() {
      const map = {
        company: "",
        bank: "YH",
        insurance: "BX"
      };
      const mapData = map[this.currentType];

      const key = "globalAssetsColumn" + mapData;
      this.globalAssetsColumnData = Config[key];

      const key2 = "equityColumn" + mapData;
      this.equityColumnData = Config[key2];

      const key3 = "profitColumn" + mapData;
      this.profitColumnData = Config[key3];

      const key4 = "memoColumn" + mapData;
      this.memoColumnData = Config[key4];

      const mapTitle = {
        company: [
          "Profitability Ratios",
          "Operational Ratios",
          "Structure Ratios",
          "Per Employee Ratios"
        ],
        bank: [
          "Profitability ratios",
          "Capital ratios",
          "Operations ratios",
          "Liquidity ratios"
        ],
        insurance: ["Profitability Ratios", "Structure Ratios", "none", "none"]
      };

      this.ratios1Title = mapTitle[this.currentType][0];
      this.ratios2Title = mapTitle[this.currentType][1];
      this.ratios3Title = mapTitle[this.currentType][2];
      this.ratios4Title = mapTitle[this.currentType][3];
      // radios
      if (mapData == "") {
        this.ratios1ColumnData = Config.profitabilityColumn;
        this.ratios2ColumnData = Config.operationalColumn;
        this.ratios3ColumnData = Config.structureColumn;
        this.ratios4ColumnData = Config.perEmployeeColumn;
      } else if (mapData == "YH") {
        this.ratios1ColumnData = Config.profitabilityColumnYH;
        this.ratios2ColumnData = Config.CapitalRatiosYH;
        this.ratios3ColumnData = Config.OperationsRatiosYH;
        this.ratios4ColumnData = Config.LiquidityRatiosYH;
      } else {
        this.ratios1ColumnData = Config.ProfitabilityRatiosBX;
        this.ratios2ColumnData = Config.StructureRatiosBX;
      }
    },

    setTableData(data) {
      // 现金流
      try {
        this.OperatingUnit =
          data.cashFlowData["Operating cash flows"][0].original_currency;
      } catch (error) {}
      this.operatingCashFlowData = this.converData(
        data.cashFlowData["Operating cash flows"] || [],
        Config1.operatingCashFlow
      );

      try {
        this.InvestingUnit =
          data.cashFlowData["Investing cash flows"][0].original_currency;
      } catch (error) {}
      this.investingCashFlowData = this.converData(
        data.cashFlowData["Investing cash flows"] || [],
        Config1.investingCashFlow
      );

      try {
        this.financingCFUnit =
          data.cashFlowData["Financing cash flows"][0].original_currency;
      } catch (error) {}
      this.financingCashFlowData = this.converData(
        data.cashFlowData["Financing cash flows"] || [],
        Config1.financingCashFlow
      );

      try {
        this.cfBalanceUnit = data.cashFlowData["Balance"][0].original_currency;
      } catch (error) {}
      this.balanceCashFlowData = this.converData(
        data.cashFlowData["Balance"] || [],
        Config1.balance
      );

      // f10
      if (this.currentDataSource != "bvd") {
        this.KeyFinancialUnit = data.keyFinancial[0].exchange_rate_cny_usd;
        this.keyFinancialsData = this.converData(
          data.keyFinancial,
          Config.keyFinancialsColumn
        );
        this.IncomeUnit =
          data.financialStatement["Income Statement"][0]
            .exchange_rate_cny_usd || "";
        this.incomeData = this.converData(
          data.financialStatement["Income Statement"],
          Config.incomeColumn
        );

        this.balanceUnit =
          data.financialStatement["Balance Sheet"][0].exchange_rate_cny_usd ||
          "";
        this.balanceData = this.converData(
          data.financialStatement["Balance Sheet"],
          Config.balanceColumn
        );

        this.cashFlowUnit =
          data.financialStatement["Cash Flow Statement"][0]
            .exchange_rate_cny_usd || "";
        this.cashFlowData = this.converData(
          data.financialStatement["Cash Flow Statement"],
          Config.cashFlowColumn
        );
      } else {
        const map = {
          company: [
            "Profitability Ratios",
            "Operational Ratios",
            "Structure Ratios",
            "Per Employee Ratios"
          ],
          bank: [
            "Profitability ratios",
            "Capital ratios",
            "Operations ratios",
            "Liquidity ratios"
          ],
          insurance: [
            "Profitability Ratios",
            "Structure Ratios",
            "none",
            "none"
          ]
        };

        try {
          this.KeyFinancialEmployeesUnit =
            data.keyFinancial[0].original_units == "units"
              ? data.keyFinancial[0].original_currency
              : data.keyFinancial[0].original_units +
                " " +
                data.keyFinancial[0].original_currency;
        } catch (error) {}
        this.employeesData = this.converData(
          data.keyFinancial,
          Config.employeesColumn
        );

        try {
          this.assetsUnit =
            data.financialStatement.Assets[0].original_units == "units"
              ? data.financialStatement.Assets[0].original_currency
              : data.financialStatement.Assets[0].original_units +
                " " +
                data.financialStatement.Assets[0].original_currency;
        } catch (error) {}
        this.globalAssetsData = this.converData(
          data.financialStatement.Assets || [],
          this.globalAssetsColumnData
        );

        try {
          this.LiabilitiesUnit =
            data.financialStatement["Liabilities & Equity"][0].original_units ==
            "units"
              ? data.financialStatement["Liabilities & Equity"][0]
                  .original_currency
              : data.financialStatement["Liabilities & Equity"][0]
                  .original_units +
                " " +
                data.financialStatement["Liabilities & Equity"][0]
                  .original_currency;
        } catch (error) {}
        this.equityData = this.converData(
          data.financialStatement["Liabilities & Equity"] || [],
          this.equityColumnData
        );

        try {
          this.ProfitUnit =
            data.financialStatement["Profit & Loss Account"][0]
              .original_units == "units"
              ? data.financialStatement["Profit & Loss Account"][0]
                  .original_currency
              : data.financialStatement["Profit & Loss Account"][0]
                  .original_units +
                " " +
                data.financialStatement["Profit & Loss Account"][0]
                  .original_currency;
        } catch (error) {}
        this.profitData = this.converData(
          data.financialStatement["Profit & Loss Account"] || [],
          this.profitColumnData
        );

        try {
          this.MemoUnit =
            data.financialStatement["Memo Lines"][0].original_units == "units"
              ? data.financialStatement["Memo Lines"][0].original_currency
              : data.financialStatement["Memo Lines"][0].original_units +
                " " +
                data.financialStatement["Memo Lines"][0].original_currency;
        } catch (error) {}
        this.memoData = this.converData(
          data.financialStatement["Memo Lines"] || [],
          this.memoColumnData
        );

        try {
          this.ratios1Unit =
            data.globleRatio[map[this.currentType][0]][0].original_units ==
            "units"
              ? data.globleRatio[map[this.currentType][0]][0].original_currency
              : data.globleRatio[map[this.currentType][0]][0].original_units +
                " " +
                data.globleRatio[map[this.currentType][0]][0].original_currency;
        } catch (error) {}
        this.ratios1Data = this.converData(
          data.globleRatio[map[this.currentType][0]] || [],
          this.ratios1ColumnData
        );

        try {
          this.ratios2Unit =
            data.globleRatio[map[this.currentType][1]][0].original_units ==
            "units"
              ? data.globleRatio[map[this.currentType][1]][0].original_currency
              : data.globleRatio[map[this.currentType][1]][0].original_units +
                " " +
                data.globleRatio[map[this.currentType][1]][0].original_currency;
        } catch (error) {}
        this.ratios2Data = this.converData(
          data.globleRatio[map[this.currentType][1]] || [],
          this.ratios2ColumnData
        );
        if (this.currentType != "insurance") {
          try {
            this.ratios3Unit =
              data.globleRatio[map[this.currentType][2]][0].original_units ==
              "units"
                ? data.globleRatio[map[this.currentType][2]][0]
                    .original_currency
                : data.globleRatio[map[this.currentType][2]][0].original_units +
                  " " +
                  data.globleRatio[map[this.currentType][2]][0]
                    .original_currency;
          } catch (error) {}
          this.ratios3Data = this.converData(
            data.globleRatio[map[this.currentType][2]] || [],
            this.ratios3ColumnData
          );

          try {
            this.ratios4Unit =
              data.globleRatio[map[this.currentType][3]][0].original_units ==
              "units"
                ? data.globleRatio[map[this.currentType][3]][0]
                    .original_currency
                : data.globleRatio[map[this.currentType][3]][0].original_units +
                  " " +
                  data.globleRatio[map[this.currentType][3]][0]
                    .original_currency;
          } catch (error) {}
          this.ratios4Data = this.converData(
            data.globleRatio[map[this.currentType][3]] || [],
            this.ratios4ColumnData
          );
        }
      }
    },

    /**
     * arr 数据数组
     * column 列数组  循环转换
     */
    converData(data, column) {
      let result = {};

      column.forEach(item => {
        result[item.field] = [];
        if (!data || !data.length) {
          result[item.field].push("");
        } else {
          //只取前两年
          const twoYearData = data.slice(0,2)
          twoYearData.forEach(dataItem => {
            if (!dataItem[item.field] || dataItem[item.field] == "null") {
              dataItem[item.field] = "";
            }
            result[item.field].push(dataItem[item.field]);
          });
        }
      });
      return result;
    },

    async keyFinancialsChange() {
      const params = {
        bvdId: this.id,
        exchangeCode: this.exchangeInfo,
        stockCode: this.code,
        quarter: this.keyFinancialsQuarter
      };
      const { result } = await getCompanyFinancial(params);
      this.KeyFinancialUnit = result.keyFinancial[0].exchange_rate_cny_usd;

      this.keyFinancialsData = this.converData(
        result.keyFinancial,
        Config.keyFinancialsColumn
      );
    },

    async financialStateChange() {
      const params = {
        bvdId: this.id,
        exchangeCode: this.exchangeInfo,
        stockCode: this.code,
        quarter: this.fstatementQuarter
      };
      const { result } = await getCompanyFinancial(params);

      this.incomeData = this.converData(
        result.financialStatement["Income Statement"],
        Config.incomeColumn
      );
      this.balanceData = this.converData(
        result.financialStatement["Balance Sheet"],
        Config.balanceColumn
      );
      this.cashFlowData = this.converData(
        result.financialStatement["Cash Flow Statement"],
        Config.cashFlowColumn
      );
    },

    getChartData(result) {
      if (this.currentDataSource == "f10") {
        this.f10Chart(result);
      } else {
        this.bvdChart(result);
      }
    },

    bvdChart(result) {
      let chartResult = [];
      let operatingRevenueTotal = {
        data: [],
        name: "Operating Revenue (Turnover)",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let PLTotal = {
        data: [],
        name: "P/L Before Tax",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let cashFlowTotal = {
        data: [],
        name: "Cash Flow",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let assetsTotal = {
        data: [],
        name: "Total Assets",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      this.xData = [];
      for (let item of result["keyFinancial"]) {
        this.xData.push(item.year);
        operatingRevenueTotal.data.push(item.operating_revenue_turnover);
        PLTotal.data.push(item.p_l_before_tax);
        cashFlowTotal.data.push(item.cash_flow);
        assetsTotal.data.push(item.total_assets);
      }

      this.xData = this.xData.reverse();
      console.log("bvdChart -> this.xData", this.xData);

      chartResult.push(
        operatingRevenueTotal,
        PLTotal,
        cashFlowTotal,
        assetsTotal
      );

      if (
        !chartResult[0].data.length &&
        !chartResult[1].data.length &&
        !chartResult[2].data.length &&
        !chartResult[3].data.length
      ) {
        this.serData = [];
        return;
      }
      this.converChartData(chartResult);
    },

    f10Chart(result) {
      let chartResult = [];
      let incomTotal = {
        data: [],
        name: "Operating Income",
        unit: result.financialStatement["Income Statement"][0]
          ? result.financialStatement["Income Statement"][0]
              .exchange_rate_cny_usd
          : ""
      };
      let profitTotal = {
        data: [],
        name: "Total Profit",
        unit: result.financialStatement["Income Statement"][0]
          ? result.financialStatement["Income Statement"][0]
              .exchange_rate_cny_usd
          : ""
      };
      this.xData = [];
      for (let item of result.financialStatement["Income Statement"]) {
        this.xData.push(item.year);
        incomTotal.data.push(item.operating_income);
        profitTotal.data.push(item.total_profit);
      }

      let assetsTotal = {
        data: [],
        name: "Total Assets",
        unit: result.financialStatement["Balance Sheet"][0]
          ? result.financialStatement["Balance Sheet"][0].exchange_rate_cny_usd
          : ""
      };
      let currentAssetsTotal = {
        data: [],
        name: "Current Assets",
        unit: result.financialStatement["Balance Sheet"][0]
          ? result.financialStatement["Balance Sheet"][0].exchange_rate_cny_usd
          : ""
      };
      for (let item of result.financialStatement["Balance Sheet"]) {
        assetsTotal.data.push(item.total_assets);
        currentAssetsTotal.data.push(item.current_assets);
      }
      this.xData = this.xData.reverse();

      chartResult.push(
        incomTotal,
        profitTotal,
        assetsTotal,
        currentAssetsTotal
      );
      if (
        !chartResult[0].data.length &&
        !chartResult[1].data.length &&
        !chartResult[2].data.length &&
        !chartResult[3].data.length
      ) {
        this.serData = [];
        return;
      }
      this.converChartData(chartResult);
    },

    converChartData(result) {
      const data = result.map((item, index) => {
        const itemData = {
          name: item.name,
          type: "line",
          // stack: "dta",
          data: item.data.reverse(),
          unit: item.unit,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        return itemData;
      });
      this.serData = [];
      this.serData = data;
      console.log("converChartData -> this.serData", this.serData);
    },

    downLoadFn(data, column, fileName, rate) {
      if (!Object.keys(data).length) return;
      let result = "";
      let dataArray = [];
      dataArray = ["year", ...data.year];

      result = dataArray.join(",") + `\n`; //先遍历得到表头信息
      column.forEach(item => {
        if (item.label != "year") {
          result += `${item.label + "\t"},`;
          data[item.field].map(dataItem => {
            result += `${dataItem + "\t"},`;
          });
          result += "\n";
        }
      });

      result += "Exchange rate:" + "\t" + rate + "\t" + "\n";

      //encodeURIComponent解决中文乱码
      let uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(result);
      //通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = `${fileName}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },

  computed: {
    ...mapState({
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  }
};
</script>

<style scoped>
.qurarter_cls {
  margin: 10px 0px;
}

.third_module {
  padding: 10px;
  border: 1px solid #dee2e65c;
  margin-bottom: 10px;
}

.module_title {
  font-size: 16px;
  margin-bottom: 10px;
}
.module_title .unit {
  font-size: 14px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
  padding: 0px 20px !important;
  top: 10px;
}
.paddingBtn {
  padding: 10px 20px !important;
}
</style>